// steps — passos numerados em cartões empilhados; cada um desliza com back easing, o
// número salta na cor de destaque e o passo anterior recua quando o próximo chega.
import React from 'react';
import { interpolate } from 'remotion';
import type { StepsProps } from './schema';
import { CARD, EASE_BACK, EASE_OUT, Pop, SAFE_W, fitFont, onAccent, prog, useGFrame, type GraphicComponentProps } from './common';

const W = SAFE_W - 10;
const BADGE = 66;

export const Steps: React.FC<GraphicComponentProps<StepsProps>> = ({ props, totalFrames, accent }) => {
  const f = useGFrame();
  const items = props.items.slice(0, 3);
  const n = items.length;
  const first = 5;
  const step = Math.max(6, Math.min(16, Math.floor((totalFrames * 0.58 - first) / Math.max(1, n))));
  const longest = items.reduce((a, b) => (b.length > a.length ? b : a), '');
  const size = fitFont(longest, { weight: 700, max: 42, min: 32, maxWidth: W - 60 - BADGE - 26 });
  const ink = onAccent(accent);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16, width: W }}>
      {items.map((item, i) => {
        const t0 = first + i * step;
        const inP = prog(f, t0, t0 + 9, EASE_BACK);
        const fade = prog(f, t0, t0 + 6, EASE_OUT);
        const badge = prog(f, t0 + 3, t0 + 10, EASE_BACK);
        const next = i < n - 1 ? prog(f, t0 + step, t0 + step + 6, EASE_OUT) : 0;
        return (
          <div
            key={i}
            style={{
              ...CARD,
              borderRadius: 26,
              padding: '20px 30px 20px 22px',
              display: 'flex',
              alignItems: 'center',
              gap: 26,
              opacity: fade,
              translate: `${interpolate(inP, [0, 1], [-70, 0]).toFixed(1)}px 0px`,
              filter: `blur(${((1 - fade) * 8).toFixed(2)}px)`,
              scale: String(1 - 0.03 * next),
            }}
          >
            <Pop at={t0 + 4} />
            <div
              style={{
                width: BADGE,
                height: BADGE,
                flexShrink: 0,
                borderRadius: 999,
                background: accent,
                color: ink,
                fontWeight: 900,
                fontSize: 36,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                scale: String(Math.max(0.01, interpolate(badge, [0, 1], [0.4, 1]))),
                boxShadow: '0 6px 18px rgba(0,0,0,0.35)',
                paddingTop: 2,
                filter: `saturate(${(1 - 0.7 * next).toFixed(2)})`,
                opacity: 1 - 0.4 * next,
              }}
            >
              {i + 1}
            </div>
            <div style={{ fontWeight: 700, fontSize: size, lineHeight: 1.14, color: '#fff', opacity: 1 - 0.42 * next }}>{item}</div>
          </div>
        );
      })}
    </div>
  );
};
